import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";
import { COST_HINT_TYPE } from "@/static/costHintTypeEnum";

export class CostHint {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsNumber()
  recordStampId!: number;
  @Expose()
  @IsEnum(COST_HINT_TYPE)
  type!: COST_HINT_TYPE;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsBoolean()
  isLocked!: boolean;
  @Expose()
  @IsNumber()
  count!: number;
  @Expose()
  @IsString()
  @IsOptional()
  lastUsed!: string | null;
}

export class CostHintResponse extends GenericTableResponse<CostHint> {
  @Expose()
  @IsArray()
  @Type(() => CostHint)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<CostHint>;
}
